export const auth = state => state.auth
export const user = state => state.user
export const staffType = state => state.staffType



// WEBPACK FOOTER //
// ./src/store/getters.js